import { render, staticRenderFns } from "./ExamAttributeDetailsAction.vue?vue&type=template&id=cbccd992&scoped=true&"
import script from "./ExamAttributeDetailsAction.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeDetailsAction.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeDetailsAction.vue?vue&type=style&index=0&id=cbccd992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbccd992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VSpacer})
